import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    // eslint-disable-next-line no-undef
    HSCore.components.HSMask.init('[data-hs-mask-options]');
    setTimeout(() => this.element.removeAttribute('data-controller'), 500);
  }
}
